export const fallbackLng = "sv";
export const languages = [fallbackLng, "en", "de", "da"];
export const defaultNS = "translation";

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
    backendOptions: [
      {
        expirationTime: 30 * 1000,
      },
    ],
  };
}
